module.exports = __webpack_public_path__ + "img/loading-indicator-ring.24171779.svg";